// extracted by mini-css-extract-plugin
export default {"container":"l1-z","heading":"m1-z","links":"n1-z","copy":"o1-z","subCopy":"p1-z","linksLeft":"q1-z","linksCenter":"r1-z","linksRight":"s1-z","link":"t1-z","onlyLink":"u1-z"};